import { render } from "./Introduction.vue?vue&type=template&id=5e90d79a&scoped=true&ts=true"
import script from "./Introduction.vue?vue&type=script&lang=ts"
export * from "./Introduction.vue?vue&type=script&lang=ts"

import "./Introduction.vue?vue&type=style&index=0&id=5e90d79a&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e90d79a"]])

export default __exports__